module.exports = __webpack_public_path__ + "static/media/motor-cycle-removebg-preview.2f72b0ad.png";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/Wizard/parts/images/new/png-images/motor-cycle-removebg-preview.png
// module id = 3031
// module chunks = 0